import firebase from 'firebase/app';
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

const config = {
    apiKey: "AIzaSyAj65ru-hG2AtskNJ3yht7uouh8f0qkEqc",
    authDomain: "react-messaging-app-fb8ca.firebaseapp.com",
    databaseURL: "https://react-messaging-app-fb8ca.firebaseio.com",
    projectId: "react-messaging-app-fb8ca",
    storageBucket: "react-messaging-app-fb8ca.appspot.com",
    messagingSenderId: "180889670692",
    appId: "1:180889670692:web:6c0a83ceedcfbcf94eb4b1",
    measurementId: "G-9C9JK9T4WC"
  };

  firebase.initializeApp(config);

  export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js